// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;Deep calls to deep in the thunder of your waterfalls;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;all your breakers and waves have gone over me.<br> </p> </div></div>";
// Exports
module.exports = code;